<template>
    <v-dialog max-width="50%" v-model="dialog">
        <v-card class="ma-0 pa-0">
            <v-card-actions class="ma-0 pa-0">
                <v-spacer></v-spacer>
                <v-btn icon class="ma-1" color="red" @click="onClose">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-actions>
            <v-card-actions class="py-0">

                <v-slide-group
                        v-model="model"
                        active-class="success"
                        show-arrows>
                    <v-slide-item v-for="emotion in emotions" :key="emotion" v-slot="{ active, toggle }">
                        <v-card :color="active ? 'green' : 'lighten-1'"
                                class="ma-1"
                                elevation="0"
                                height="150"
                                width="150"
                                outlined
                                @click="toggle">
                            <v-progress-circular v-if="getUrl(code, emotion) == undefined"
                                                 style="margin-top: 55px; margin-left: 60px"
                                                 indeterminate
                                                 color="orange"
                            ></v-progress-circular>
                            <v-img v-else max-width="150"
                                   :src="getUrl(code, emotion)">
                            </v-img>
                        </v-card>

                    </v-slide-item>
                </v-slide-group>

            </v-card-actions>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="ma-2"
                       color="primary"
                       @click="onPressSave">Set
                </v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import {HeroKind} from "@/modules/redactor/models/hero/HeroKind";
import firebase from "firebase";

export default {
    name: "utils-popup-select-emotion",
    props: {},
    components: {},
    data: () => ({
        dialog: false,
        onComplete:null,
        model: null,
        imagesUrls: [],
        code: 0,
    }),
    computed: {
        emotions(){
            var character = HeroKind.getValueByCode(this.code);
            if (!character){
                return []
            }
            var data = [];
            for (let i = 0; i < character.emotions; i++) {
                data.push(i)
            }
            return data;
        },
    },
    methods: {
        show(code, emotion, onComplete) {
            this.code = code
            this.model = emotion
            this.dialog = true
            this.onComplete = onComplete
            for (let i = 0; i < this.emotions.length; i++) {
                this.getImage(code, i);
            }
        },
        hide() {
            this.dialog = false
        },
        onClose() {
            this.hide()
        },
        onPressSave() {
            if (this.model == null || this.model == undefined){
                return;
            }
            this.dialog = false
            this.onComplete(this.model)
        },
        getUrl(code, emotion){
            return this.imagesUrls[code + "*" + emotion]
        },
        getImage(code, emotion){
            var character = HeroKind.getValueByCode(code);
            firebase.storage()
                .ref('assets/ch/'+character.key+'_'+emotion+'.png')
                .getDownloadURL().then((url) => {
                this.imagesUrls[code + "*" + emotion] = url;
                this.$forceUpdate();
            }).catch(() => {
                this.imagesUrls[code + "*" + emotion] = require("@/modules/muiutils/resources/no-image-icon.png");
                this.$forceUpdate();
            });
        },
    },
}
</script>

<style scoped>

</style>